import { NgModule, Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { UserDataApi, LoopBackAuth } from '../../../../assets/js/lb-sdk';

interface ChangeEmailForm {
  id?: number,
  email?: string,
  previousEmail?: string
};

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css']
})
export class ChangeEmailComponent implements OnInit {
  data: ChangeEmailForm;
  error: string;
  loading: boolean = false;

  constructor(
    public modal: BsModalRef,
    private userDataApi: UserDataApi,
    private loopBackAuth: LoopBackAuth
  ) { }

  ngOnInit() {
    this.data = this.data ? {
      ...this.data,
      previousEmail: this.data.email
    } : {};
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    this.error = undefined;
    if (form.valid) {
      this.loading = true;
      this.userDataApi
        .changeEmail({
          oldEmail: this.data.previousEmail,
          newEmail: this.data.email
        })
        .pipe(finalize(() => {
          this.loading = false;
        }))
        .subscribe(() => {
          if (!this.data.id) {
            this.userDataApi
              .findById(this.getUser().id, { include: { roles: 'role' } })
              .subscribe(user => {
                this.loopBackAuth.setUser(user);
              });
          }
          this.modal.content.result = 'done';
          this.modal.hide();
        }, error => {
          console.log(error)
          this.error = (
            error && error.message && error.message.indexOf('Email already exists')
          ) ? 'Email already exists' : 'Failed to update email';
        });
    }
  }

  getUser() {
    if (this.data.id) {
      return {
        id: this.data.id,
        email: this.data.previousEmail
      };
    } else {
      return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
    }
  }
}
